'use client';

// core (MUI)
import { frFR as frFRCore, arSA as arSACore } from '@mui/material/locale';
// date pickers (MUI)
import {
  enUS as enUSDate,
  frFR as frFRDate,
} from '@mui/x-date-pickers/locales';
// data grid (MUI)
import {
  enUS as enUSDataGrid,
  frFR as frFRDataGrid,
} from '@mui/x-data-grid/locales';

// ----------------------------------------------------------------------

export const allLangs = [
  {
    value: 'en' as const,
    label: 'English',
    countryCode: 'GB',
    adapterLocale: 'en',
    numberFormat: { code: 'en-US', currency: 'KES' },
    systemValue: {
      components: { ...enUSDate.components, ...enUSDataGrid.components },
    },
  },
  {
    value: 'fr' as const,
    label: 'Français',
    countryCode: 'FR',
    adapterLocale: 'fr',
    numberFormat: { code: 'fr-FR', currency: 'EUR' },
    systemValue: {
      components: { ...frFRCore.components, ...frFRDate.components, ...frFRDataGrid.components },
    },
  },
  {
    value: 'rw' as const,
    label: 'Kinyarwanda',
    countryCode: 'RW',
    adapterLocale: 'en',
    numberFormat: { code: 'rw-RW', currency: 'RWF' },
    systemValue: {
      components: { ...enUSDate.components, ...enUSDataGrid.components },
    },
  },
  {
    value: 'sw' as const,
    label: 'Kiswahili',
    countryCode: 'KE',
    adapterLocale: 'en',
    numberFormat: { code: 'sw-KE', currency: 'KES' },
    systemValue: {
      components: { ...enUSDate.components, ...enUSDataGrid.components },
    },
  },
  {
    value: 'ar' as const,
    label: 'العربية',
    countryCode: 'SA',
    adapterLocale: 'ar',
    numberFormat: { code: 'ar-SA', currency: 'SAR' },
    systemValue: {
      components: { ...arSACore.components, ...enUSDate.components, ...enUSDataGrid.components },
    },
  },
];
